import { colors } from '../../utils/colors'

export const jobApplicationsStyles = {
  container: { width: '100%', padding: '1.1% 4.3% 4.3% 4%' },
  heading: {
    fontSize: '25px',
    fontWeight: 700,
    lineHeight: '35.68px',
    color: colors.principal,
    marginBottom: '10px',
  },
  jobApplicationsSearch: {
    border: `1px solid ${colors.principal}`,
    padding: '25px 63px 25px 36px',
    borderRadius: '10px',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    marginBottom: '20px',
  },
  loading: {
    width: '100%',
    height: '30vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noResultsContainer: {
    width: '100%',
    height: '50vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noResults: {
    textAlign: 'center',
    padding: '20px 0px',
    fontWeight: 'bold',
  },
  results: { display: 'flex', flexDirection: 'column', rowGap: '10px' },
  applicationsList: {},
  containerMobile: { width: '100%', padding: '6% 4.3% 8% 4%' },
  jobApplicationsSearchMobile: {
    border: `1px solid ${colors.principal}`,
    padding: '25px 36px 25px 36px',
    borderRadius: '10px',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    marginBottom: '20px',
  },
  resultsMobile: { display: 'flex', flexDirection: 'column', rowGap: '20px' },
}
